import { Component } from '@angular/core';
export interface MaterialCost {
  material: string;
  specifications: string;
  quantity: number;
  unit: string;
  perKgRate: number;
  totalCost: number;
}
@Component({
  selector: 'app-material-cost',
  templateUrl: './material-cost.component.html',
  styleUrl: './material-cost.component.css'
})
export class MaterialCostComponent {
  displayedColumns: string[] = ['material', 'specifications', 'quantity', 'unit', 'perKgRate', 'totalCost'];

  dataSource: MaterialCost[] = [
    {
      material: 'Soil (locally sourced)',
      specifications: 'Compacted to 95% Proctor density, CBR ≥ 8%',
      quantity: 2700000,
      unit: 'kg',
      perKgRate: 0.5,
      totalCost: 1350000
    },
    {
      material: 'Selected soil',
      specifications: 'CBR ≥ 8%, compacted to 97% density',
      quantity: 3375000,
      unit: 'kg',
      perKgRate: 0.5,
      totalCost: 1687500
    },
    {
      material: 'Crushed stone aggregates',
      specifications: '0-75 mm size, CBR ≥ 30%, compacted to 98% density',
      quantity: 1575000,
      unit: 'kg',
      perKgRate: 1.2,
      totalCost: 1890000
    },
    {
      material: 'Cement (DLC)',
      specifications: 'M10 grade, 25-30°C during laying, 7-day curing',
      quantity: 81000,
      unit: 'kg',
      perKgRate: 8,
      totalCost: 648000
    },
    {
      material: 'Sand (DLC)',
      specifications: 'M10 grade, 25-30°C during laying, 7-day curing',
      quantity: 2700000,
      unit: 'kg',
      perKgRate: 1.5,
      totalCost: 4050000
    },
    {
      material: 'Aggregates (DLC)',
      specifications: 'M10 grade, 25-30°C during laying, 7-day curing',
      quantity: 708750,
      unit: 'kg',
      perKgRate: 1.2,
      totalCost: 850500
    },
    {
      material: 'Cement (PQC)',
      specifications: 'M40 grade, slump 25-50 mm, 280-320 mm thick',
      quantity: 226800,
      unit: 'kg',
      perKgRate: 8,
      totalCost: 1814400
    },
    {
      material: 'Sand (PQC)',
      specifications: 'M40 grade, slump 25-50 mm, 280-320 mm thick',
      quantity: 378000,
      unit: 'kg',
      perKgRate: 1.5,
      totalCost: 567000
    },
    {
      material: 'Aggregates (PQC)',
      specifications: 'M40 grade, slump 25-50 mm, 280-320 mm thick',
      quantity: 992250,
      unit: 'kg',
      perKgRate: 1.2,
      totalCost: 1190700
    },
    {
      material: 'Granular material',
      specifications: 'Compacted soil/GSB, 1.5 m each side',
      quantity: 5700000,
      unit: 'kg',
      perKgRate: 0.8,
      totalCost: 4560000
    }
  ];
}